<a href="/">⬅️ back to homepage</a>

<style>
	a {
		color: #3cff00;
	}
	a:visited {
		color: #32d600;
	}
</style>
